import _ from 'lodash'
import { ActionTypes } from '../../constants'

const processStatistics = (action) => {
  const { students } = action.group

  return _
    .chain(action.statistics)
    .map((result) => _.update(result, 'student', () => students[result.student.id].object ))
    .sortBy((statistic) => statistic.student.fullName.toLowerCase())
    .value()
}

const statistic = (state = {
  object: null,
  fetching: false,
  error: null,
  updatedOn: null,
  didInvalidate: false
}, action) => {
  switch(action.type) {
  case ActionTypes.CLASS_STATISTICS_REQUEST:
    return { ...state, fetching: true, error: null }

  case ActionTypes.CLASS_STATISTICS_RECEIVING_SUCCESS:
    return {
      ...state,
      fetching: false,
      updatedOn: action.updatedOn,
      object: processStatistics(action),
      didInvalidate: false
    }

  case ActionTypes.CLASSES_RECEIVING_FAILURE:
    return {
      ...state,
      fetching: false,
      error: action.error,
      didInvalidate: true
    }

  default:
    return state
  }
}

export default statistic
